import { render, staticRenderFns } from "./statisticArea.vue?vue&type=template&id=757ec0f0&"
import script from "./statisticArea.vue?vue&type=script&lang=js&"
export * from "./statisticArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757ec0f0')) {
      api.createRecord('757ec0f0', component.options)
    } else {
      api.reload('757ec0f0', component.options)
    }
    module.hot.accept("./statisticArea.vue?vue&type=template&id=757ec0f0&", function () {
      api.rerender('757ec0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/statisticArea.vue"
export default component.exports